import * as React from 'react';
import classnames from 'classnames';
import styles from './productStockMessage.module.css';
export const ProductStockMessage = ({ message, color, }) => (React.createElement("div", { className: classnames({
        [styles.ProductStockMessage]: true,
        [styles.ProductStockMessageGreen]: color === 'green',
        [styles.ProductStockMessageRed]: color === 'red',
        [styles.ProductStockMessageAmber]: color === 'amber',
    }) }, message));
